<div class="input-data-container">
  <div class="input-container">

    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' [name]="document.NAME + document.ID" [id]="document.NAME + document.ID" [(ngModel)]="document.VALUE"
        [disabled]="disabled" (ngModelChange)="valueChanged()" />
      <label class="checkbox-custom-label" [for]="document.NAME + document.ID">
        <span *ngIf="!editFlag">{{document.NAME}}</span>
      </label>

      <input *ngIf="editFlag" #inputText type="text" class="input-field-label rbv-field" [(ngModel)]="document.NAME"
        [name]="document.NAME" [disabled]="disabled" [placeholder]="placeholder" (blur)="onBlur()" (focus)="onFocus()"
        (paste)="onPaste($event)" (keypress)="onKeyPress($event)" (ngModelChange)="nameChanged()"
        (keydown.enter)="accept()" (keydown.escape)="clear()" autocomplete="off"/>
    </div>

    <button *ngIf="!editFlag" class="action-button hinted no-toggle small" (click)="onLabelClick()" [disabled]="disabled">
      <fa name="fa fa-pencil"></fa>
      <div class="hint">Edit Custom Document</div>
    </button>

     <button class="action-button hinted no-toggle small warning" (click)="onRemove()" [disabled]="disabled">
       <fa name="fa fa-ban"></fa>
       <div class="hint">Remove Custom Document</div>
     </button>
  </div>
</div>
